<app-toolbar></app-toolbar>

@if (showHeader) {
<header>
<h1>Hello, {{ title() }}</h1>
<p>Congratulations! With Figaro Excel file we can show you what we did. 🎉</p>
</header>
}

<main>
  <router-outlet/>
</main>